import '../../lib/date.iso8601'

export function consentCutoffHoursRemaining(consent_cutoff) {
  return Math.max(
    1,
    Math.floor((Date.parse(consent_cutoff) - new Date().getTime()) / 3600000)
  )
  //return 24 - Math.floor((new Date - Date.parse(props.card.target.created_at)) / 3600000)
}
